import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { reduxPollingMiddleware, reduxPollingNamespace, reduxPollingReducer } from 'redux-polling';
import rootReducer from './reducers';
import { apiSlice } from '../api/apiSlice';
import { smartCaptureApi } from 'features/govtId/capture/api';
import { startConnectivityMonitor } from 'features/connectivity/lib/monitor';

const persistConfig = {
    key: 'authenticating',
    storage: storageSession,
    blacklist: [
        'REDUX_POLLING',
        // govtId feature slice — holds all govt-ID state (processedData,
        // images, captureProperties, common, idProperties); blacklisted so it is
        // cleared on reload, matching the legacy reducers it replaced.
        'govtId',
        'govtIdV2',
        'preIdentity',
        'kba',
        'connectivity',
        apiSlice.reducerPath,
        smartCaptureApi.reducerPath,
    ],
};

const createRootReducer = () =>
    combineReducers({
        [reduxPollingNamespace]: reduxPollingReducer,
        ...rootReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
        [smartCaptureApi.reducerPath]: smartCaptureApi.reducer,
    });

export const store = configureStore({
    reducer: persistReducer(persistConfig, createRootReducer()),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false,
        }).concat(reduxPollingMiddleware, apiSlice.middleware, smartCaptureApi.middleware),
});

export const persistor = persistStore(store);

startConnectivityMonitor(store.dispatch);

// Retained for the legacy http.js request interceptor — removed in Phase 8.
window.store = store;
